import BrandModelListTable from './brandModelListTable.container';

export default BrandModelListTable